
const howToUse = () => {

    const querySelectors = {
        bodyTag: document.querySelector('body'),
        openPopupBtn: document.querySelector('#open-how-to-use-popup'),
        closePopupBtn: document.querySelector('#close-how-to-use-popup'),
        popup: document.querySelector('#how-to-use-popup'),
        popupSubtitle: document.querySelector('#how-to-use-popup .fitxr-title'),
        popupTitle: document.querySelector('#how-to-use-popup .fitxr-title'),
        popupSteps: document.querySelectorAll('.how-to-use__list-item'),
    }

    const animateContent = () => {
        querySelectors.popupSteps.forEach((popupStep, index) => {
            setTimeout(() => {
                popupStep.style.opacity = 1;
                popupStep.style.translateY = 0;
            }, (index + 1) * 150)
        });
    }

    const openPopup = (e) => {
        e.preventDefault();

        querySelectors.popup.style.top = 0;
        querySelectors.closePopupBtn.classList.add('active');

        animateContent();


        setTimeout(() => {
            querySelectors.popup.style.opacity = 1;
            querySelectors.bodyTag.classList.add('no_scroll');
        }, 150);
    }

    const closePopup = (e) => {
        e.preventDefault();

        querySelectors.closePopupBtn.classList.remove('active');
        querySelectors.popup.style.top = '100%';

        querySelectors.bodyTag.classList.remove('no_scroll');

        setTimeout(() => {
            querySelectors.popup.style.opacity = 0;
        }, 300);
    }

    const setupListeners = () => {
        querySelectors.openPopupBtn.addEventListener('click', openPopup);
        querySelectors.closePopupBtn.addEventListener('click', closePopup);
    }

    return {
        init: () => {
            if (querySelectors.popup) {
                setupListeners();
            }
        },
    }
}

export default howToUse;
